<head>
    <!-- Meta per Google -->
    <meta name="description" content="CIFRIS24 - Our second national Congress, in the eternal city of Rome.">

    <!-- Meta per Facebook -->
    <meta property="og:title" content="DeCifris.it: CIFRIS24">
    <meta property="og:description" content="CIFRIS24 - Our second national Congress, in the eternal city of Rome.">
    <meta property="og:image" content="https://www.decifris.it/assets/images/logos/logo.jpg">
    <meta property="og:url" content="https://www.decifris.it/cifris24">
    <meta property="og:type" content="website">

    <!-- Meta per Twitter -->
    <meta name="twitter:card" content="summary_large_image">
    <meta name="twitter:title" content="DeCifris.it: CIFRIS24">
    <meta name="twitter:description" content="CIFRIS24 - Our second national Congress, in the eternal city of Rome.">
    <meta name="twitter:image" content="https://www.decifris.it/assets/images/logos/logo.jpg">
    <meta name="twitter:url" content="https://www.decifris.it/cifris24">

    <!-- Meta per Instagram -->
    <meta property="og:type" content="instapp:photo">
    <meta property="og:site_name" content="DeCifris.it: CIFRIS24">
    <meta property="og:title" content="DeCifris.it: CIFRIS24">
    <meta property="og:description" content="CIFRIS24 - Our second national Congress, in the eternal city of Rome.">
    <meta property="og:image" content="https://www.decifris.it/assets/images/logos/logo.jpg">
    <meta property="og:image:width" content="1200">
    <meta property="og:image:height" content="630">

    <!-- Meta per LinkedIn -->
    <meta property="og:title" content="DeCifris.it: CIFRIS24">
    <meta property="og:description" content="CIFRIS24 - Our second national Congress, in the eternal city of Rome.">
    <meta property="og:image" content="https://www.decifris.it/assets/images/logos/logo.jpg">
    <meta property="og:url" content="https://www.decifris.it/cifris24">
    <meta property="og:type" content="website">

    <!-- Meta per WhatsApp -->
    <meta property="og:title" content="DeCifris.it: CIFRIS24">
    <meta property="og:description" content="CIFRIS24 - Our second national Congress, in the eternal city of Rome.">
    <meta property="og:image" content="https://www.decifris.it/assets/images/logos/logo.jpg">
    <meta property="og:url" content="https://www.decifris.it/cifris24">

    <!-- Meta per Telegram -->
    <meta property="og:title" content="DeCifris.it: CIFRIS24">
    <meta property="og:description" content="CIFRIS24 - Our second national Congress, in the eternal city of Rome.">
    <meta property="og:image" content="https://www.decifris.it/assets/images/logos/logo.jpg">
    <meta property="og:url" content="https://www.decifris.it/cifris24">
</head>



<h1> REGISTRATION </h1>
<table class="fee-table">
    <tbody>
        <tr>
            <td class="item"><b>MAIN EVENT</b> <br> September 25th, 26th</td>
            <td class="fee">260 EUR</td>
        </tr>
        <tr>
            <td class="item"><b>WORKSHOP</b> <br> September 27th</td>
            <td class="fee">150 EUR</td>
        </tr>
        <tr>
            <td class="item"><b>MAIN EVENT + WORKSHOP</b> <br> September 25th, 26th, 27th</td>
            <td class="fee">350 EUR</td>
        </tr>
        <tr>
            <td colspan="2">
                <hr>
            </td>
        </tr><!------------------------------>
        <tr>
            <td class="item"><b> + SOCIAL DINNER</b> <br> Evening of September 25th</td>
            <td class="fee"> + 50 EUR</td>
        </tr>
    </tbody>
</table>
<h2>MAIN EVENT (Sept. 25th, 26th)</h2>
The fee covers
<ul>
    <li>Free entrance to the main conference room;</li>
    <li>Coffee breaks and lunches (September 25th and 26th).</li>
</ul>
and doesn't cover
<ul>
    <li>Workshops;</li>
    <li>Social dinner.</li>
</ul>
<h2>WORKSHOPS (Sept. 27th)</h2>
The fee covers
<ul>
    <li>Free entrance to the workshop rooms;</li>
    <li>Coffee breaks and lunches (September 27th).</li>
</ul>
and doesn't cover
<ul>
    <li>Main event;</li>
    <li>Social dinner.</li>
</ul>
<h2>MAIN CONFERENCE AND WORKSHOPS (Sept. 25th, 26th, 27th)</h2>
The fee covers
<ul>
    <li>Free entrance to the main conference room;</li>
    <li>Free entrance to the workshop rooms;</li>
    <li>Coffee breaks and lunches (September 25th, 26th and 27th).</li>
</ul>
and doesn't cover
<ul>
    <li>Social dinner.</li>
</ul>
<h2> SOCIAL DINNER (Sept. 25th)</h2>
<p>
    The additional fee for the social dinner is 50 EUR, and covers the dinner of September 25th.
    <br> <br>
    It is possible to join the social dinner with a Companion (Companion fee: 50 EUR), subject to the availability of
    seats at the venue. Please select the <b>Companion fee</b> option below to pay for a companion, then send an
    email to
    <a href="mailto:cifris24@decifris.it">cifris24&#64;decifris.it</a>.
</p>
<hr><!------------------------------------------------------------------------>

<h1> PAYMENT </h1>
<p>
    Before paying, please send an email to <a href="mailto:cifris24@decifris.it">cifris24&#64;decifris.it</a> to
    register <b>and receive the correct reason for payment</b>.
    <br>
    The payment method is wire transfer:
    <br>
</p>
<p style="margin-left: 20px;">
    ACCOUNT HOLDER: Associazione De Componendis Cifris
    <br>
    IBAN: IT 61 Q 08304 01810 000010412063
    <br>
    BIC/SWIFT: CCRTIT2T76A
    <br>
    BANK NAME: Cassa di Trento Credito Cooperativo Italiano
    <br>
    REASON FOR PAYMENT: [to be explained in the email]
</p>
<p>
    In the email, please specify whether you pay yourself or your company/institution pays for you (in that
    case,
    please also attach its fiscal data). <br>
</p>
<p style="color: red;">
    Registration Deadline: July 26th, 2024.
</p>